import React, { Component, Fragment } from "react";
import { properties } from "../constants/Propertise";
import { api } from "../api/api";
import DefaultMessages from "./DefaultMessages";
import { Redirect } from "react-router-dom";

class WelcomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navMenulist: [],
      isPending: true,
      hasError: false,
    };
  }

  componentDidMount() {
    // if(localStorage.getItem('webqMenuConfig') === null){
    //   this.getAccessControlPages();
    // } else {
    //   this.setState({
    //     navMenulist : localStorage.getItem('webqMenuConfig')
    //   });
    // }
  }

  getAccessControlPages() {
    let menuConfigUrl = "rolepage/";
    api.get(menuConfigUrl).then((menuResult) => {
      let pageNames;
      let updatePages = [];
      let role = localStorage.getItem("webqRoles").split(",");
      menuResult.data.map((accessControlPages) => {
        role.map((element) => {
          if (element === accessControlPages["roleName"]) {
            updatePages.push(accessControlPages["pageName"]);
          }
        });
      });

      if (updatePages.length > 0) {
        pageNames = [...new Set(updatePages)];
      }
      localStorage.setItem("webqMenuConfig", pageNames?.toString());

      this.setState({
        navMenulist: pageNames?.toString(),
        isPending: false,
        hasError: false,
      });
    });
  }

  render() {
    if (
      localStorage.getItem("roles") !== null &&
      localStorage.getItem("roles") !== undefined &&
      localStorage.getItem("roles") !== ""
    ) {
      return <Redirect to={`${process.env.PUBLIC_URL}/applicationsList`} />;
    } else {
      return (
        <Fragment>
          <DefaultMessages
            isPending={this.state.isPending}
            apiError={this.state.hasError}
            count={properties.pleaseWaitPageCount}
          />
        </Fragment>
      );
    }
  }
}

export default WelcomePage;
